export const JOB_SEARCH_URL = "/jobs/search/";
export const JOB_WORK_URL = "/jobs/work/";
export const JOB_WAIT_URL = "/jobs/wait/";
export const JOB_ARCHIVE_URL = "/jobs/archive/";
export const JOB_PICK_EXECUTOR_URL = "/jobs/set/";
export const JOB_UNSET_EXECUTOR_URL = "/jobs/unset/";
export const JOB_SUBMIT_URL = "/jobs/submit/";
export const JOB_CHANGE_URL = "/jobs/change/";
export const JOB_CHANGE_AI_TEXT_URL = "/jobs/change/ai/text/";
export const JOB_CHANGE_AI_KEYWORDS_URL = "/jobs/change/ai/keywords/";
export const JOB_CHANGE_CORRECT_URL = "/jobs/change/correct/";
export const JOBS_PAID_URL = "/jobs/paid/";
export const JOB_ADD_URL = "/jobs/add/";
